class ProductFormComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.cartItems = document.querySelector('cart-items');
    this.isCartPage = !!document.body.classList.contains('template-cart');
    this.isInsideCartDrawer = !!this.closest('cart-drawer');

    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  disconnectedCallback() {
    this.form.removeEventListener('submit', this.onSubmitHandler);
  }

  onSubmitHandler(event, trigger = null) {
    if (event) event.preventDefault();

    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButton.setAttribute('disabled', true);
    this.submitButton.classList.add('button--loading');
    const addToCartBehavior = this.submitButton.dataset.addToCartBehavior;

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    let sectionsToFetch = [];
    if (this.isInsideCartDrawer) {
      sectionsToFetch = [...sectionsToFetch, ...this.cartItems.sectionsToFetch];
    }
    else if (this.cartDrawer) {
      sectionsToFetch = [
        ...sectionsToFetch,
        ...this.cartDrawer.getSectionsToRender().map(section => section.section),
      ];
    }
    else if (this.isCartPage) {
      sectionsToFetch = [
        ...sectionsToFetch,
        ...this.cartItems.getCartSectionsToRender().map(section => section.section),
        ...this.cartItems.getCartRelatedSection().map(section => section.section),
      ];
    }
    if (this.cartNotification) {
      sectionsToFetch = [
        ...sectionsToFetch,
        ...this.cartNotification.getSectionsToRender().map(section => section.section),
      ];
    }

    let uniqueSectionsToFetch = [
      ...new Set(sectionsToFetch),
    ];

    const formData = new FormData(this.form);
    formData.append('sections', uniqueSectionsToFetch);
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then(response => response.json())
      .then((parsedState) => {
        if (parsedState.status == 422) {
          // When quantity error
          this.cartNotification?.renderQuantityError(formData.get('inventory_quantity'), this.submitButton);

          // Items could still have been added despite the error, so refresh the cart state
          this.dispatchEvent(this.cartDrawer, 'cart-drawer:render-drawer');
          return;
        }

        if (this.isInsideCartDrawer) {
          this.cartItems.updateContent(parsedState);
          return;
        }

        if (this.cartDrawer) {
          this.dispatchEvent(this.cartDrawer, 'cart-drawer:render-contents', {
            parsedState: parsedState,
          });
        }
        else {
          // on the cart page
          this.cartItems.updateContent(parsedState, null, null, true);
        }

        // for quick-shop triggers
        if (this.closest('dialog')) {
          this.submitButton = this.closest('dialog').querySelector('[command="show-modal"]');
        }

        switch (addToCartBehavior) {
        case 'open_cart_drawer':
          // Set timeout to force animation. Because content is just updated with renderContents
          setTimeout(() => {
            this.dispatchEvent(this.cartDrawer, 'cart-drawer:open', {
              trigger: trigger || this.submitButton,
            });
          }, 100);
          break;
        case 'show_cart_notification':
          if (!this.isCartPage && !document.body.classList.contains('cart-drawer-is-open')) {
            this.dispatchEvent(this.cartNotification, 'cart-notification:render-contents', {
              parsedState: parsedState,
              trigger: this.submitButton,
            });
          }
          break;
        default:
          this.dispatchEvent(this.cartNotification, 'cart-notification:render-contents', {
            parsedState: parsedState,
            trigger: this.submitButton,
          });
        }
      })
      .catch((error) => {
        debug() && console.error(error);
      })
      .finally(() => {
        this.submitButton?.classList.remove('button--loading');
        this.submitButton?.removeAttribute('disabled');
      });
  }

  dispatchEvent(element, eventName, detail) {
    if (!element) return;

    element.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
        detail: detail,
      }),
    );
  }
}

if (!customElements.get('product-form-component')) {
  customElements.define('product-form-component', ProductFormComponent);
}
